import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 2v20", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M21 15V2v0a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7",
            stroke: `${color}`
          }
        )
      ]
    }
  );
};
Icon.displayName = "Utensils";
const Utensils = memo(themed(Icon));
export {
  Utensils
};
//# sourceMappingURL=utensils.js.map
